<template>
  <div :class="{ 'pointer-events-none': disabled }">
    <label class="relative flex items-center rounded cursor-pointer" for="checkbox">
      <input
        v-model="isChecked"
        type="checkbox"
        :disabled="disabled"
        class="before:content[''] peer h-6 w-6 cursor-pointer appearance-none bg-white rounded border-2 border-gray-300 checked:border-theme-600 checked:bg-theme-600"
        id="checkbox" />
      <div
        class="absolute text-white transition-opacity opacity-0 pointer-events-none peer-checked:opacity-100">
        <svg
          v-if="icon == 'check'"
          id="checkbox"
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6"
          viewBox="0 0 24 24">
          <rect id="Rectangle_146" data-name="Rectangle 146" width="24" height="24" fill="none" />
          <path
            id="Path_452"
            data-name="Path 452"
            d="M6.56,12.85l3.06,3.06,7.82-7.82"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            fill-rule="evenodd" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 16 16">
          <path fill="currentColor" d="M5 8h6v1H5z" />
        </svg>
      </div>
    </label>
  </div>
</template>

<script setup lang="ts">
const isChecked = defineModel<boolean>();

withDefaults(
  defineProps<{
    icon?: 'check' | 'dash';
    disabled?: boolean;
  }>(),
  {
    icon: 'check',
  }
);
</script>
